import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import Loader from '../../../components/Common/Loader/Loader';
import AddSubCategoryForm from '../../../components/SiteAdmin/AddSubCategoryForm/AddSubCategoryForm';
import getActiveCategories from './getActiveCategories.graphql';
import { withQuery } from '../../../hoc/withGraphql';
export class AddSubCategory extends Component {

	render() {
		const { categories, categories: { loading } } = this.props;
		return (
			<Loader type={"page"} show={loading}>
				{!loading && <AddSubCategoryForm categories={categories} />}
			</Loader>
		)
	}
}

export default compose(
	withQuery(getActiveCategories, {
		name: 'categories',
		options: {
			ssr: false,
			fetchPolicy: 'network-only'
		}
	})
)(AddSubCategory);

